import { MiddlewareAPI } from 'redux';
import { getType } from 'typesafe-actions';
import { timeSpent } from '../../timers/timeSpent/timeSpent';
import { Next } from '../../types/redux';
import { cancelEditMode, startEditMode } from '../modules/ui/actions';
import { RootActionType } from '../rootActions';

export default (_: MiddlewareAPI) =>
  (next: Next) =>
  (action: RootActionType) => {
    switch (action.type) {
      case getType(startEditMode): {
        // This will cause time_spent_edit potentially be longer than time_spent_active because
        // annotation timer for some cases is started later than this (parent edit mode case)
        timeSpent.openEditMode();
        break;
      }
      case getType(cancelEditMode): {
        if (!action.payload) break;

        timeSpent.closeEditMode(action.payload);
        break;
      }
      default:
        break;
    }
    return next(action);
  };
